import local from './settings.local';
import production from './settings.production';

const cloneConfig = (source) => JSON.parse(JSON.stringify(source));

const map = {
    local,
    development: local,
    dev: local,
    production,
    prod: production,
};

const environmentKey = (process.env.REACT_APP_ENVIRONMENT || process.env.NODE_ENV || 'development').toLowerCase();
const baseConfig = cloneConfig(map[environmentKey] || local);

const applyOverrides = (config) => {
    if (process.env.REACT_APP_API_BASE_URL) {
        config.api.baseUrl = process.env.REACT_APP_API_BASE_URL;
    }
    if (process.env.REACT_APP_COURSES_API_ENDPOINT) {
        config.api.courses.apiEndpoint = process.env.REACT_APP_COURSES_API_ENDPOINT;
    }
    if (process.env.REACT_APP_PROFILE_API_ENDPOINT) {
        config.api.profile.apiEndpoint = process.env.REACT_APP_PROFILE_API_ENDPOINT;
    }

    // Firebase configuration overrides
    if (process.env.REACT_APP_FIREBASE_API_KEY) {
        config.firebase.apiKey = process.env.REACT_APP_FIREBASE_API_KEY;
    }
    if (process.env.REACT_APP_FIREBASE_AUTH_DOMAIN) {
        config.firebase.authDomain = process.env.REACT_APP_FIREBASE_AUTH_DOMAIN;
    }
    if (process.env.REACT_APP_FIREBASE_PROJECT_ID) {
        config.firebase.projectId = process.env.REACT_APP_FIREBASE_PROJECT_ID;
    }
    if (process.env.REACT_APP_FIREBASE_STORAGE_BUCKET) {
        config.firebase.storageBucket = process.env.REACT_APP_FIREBASE_STORAGE_BUCKET;
    }
    if (process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID) {
        config.firebase.messagingSenderId = process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID;
    }
    if (process.env.REACT_APP_FIREBASE_APP_ID) {
        config.firebase.appId = process.env.REACT_APP_FIREBASE_APP_ID;
    }
    if (process.env.REACT_APP_FIREBASE_MEASUREMENT_ID) {
        config.firebase.measurementId = process.env.REACT_APP_FIREBASE_MEASUREMENT_ID;
    }

    config.environment = environmentKey;
    return config;
};

export const settings = applyOverrides(baseConfig);

